<script setup lang="ts">
import type { StoryblokAsset } from '../../types'
import type { ButtonVariant } from '~~/src/components/App/Button/index.vue'
interface Props {
  blok: {
    text: string
    variant: ButtonVariant
    enabled: boolean
    href?: string
    icon?: StoryblokAsset
  }
}

const { blok } = defineProps<Props>()

const NuxtLink = resolveComponent('NuxtLink')

const isHoveringButton = ref(false)
const showArrow = computed(() => isHoveringButton.value && blok.variant === 'primary')
const imageOptimized = computed(() => blok.icon ? optimizeImage(blok.icon.filename) : undefined)
</script>

<template>
  <Component
    :is="blok.href && blok.enabled ? NuxtLink : 'span'"
    v-editable="blok"
    :to="blok.enabled ? blok.href : null"
  >
    <AppButton
      :variant="blok.variant"
      :enabled="blok.enabled"
      class="!py-2 !px-[30px]"
      @mouseenter="isHoveringButton = true"
      @mouseleave="isHoveringButton = false"
    >
      <div center gap-2 relative class="duration-125" :class="{ 'pr-6': showArrow }">
        <img v-if="blok.icon?.filename" :src="imageOptimized" :alt="blok.icon.alt" class="w-4 h-4">
        <Text class="!text-base !font-bold">
          {{ blok.text }}
        </Text>

        <Transition name="fade">
          <div v-show="showArrow" w-4 h-4 i-mdi:arrow-right absolute right-0 top="50%" translate-y="-50%" />
        </Transition>
      </div>
    </AppButton>
  </Component>
</template>
